import { FC } from 'react';

import { Box, Typography } from '@mui/material';

import Card from '@src/main/ui/components/common/Card/Card';
import Modal from '@src/main/ui/components/common/Modal/Modal';

interface Props {
  type: string;
  onClose: () => void;
}

const AdminAddDashboardInfoModal: FC<Props> = ({ type, onClose }) => (
  <>
    <Modal open handleClose={onClose}>
      <Card width="90vw" maxWidth="650px" maxHeight="75vh">
        <Box
          sx={{
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
          }}
        >
          <Typography variant="h5">How to get the URL?</Typography>
          {getStepsByType(type)}
        </Box>
      </Card>
    </Modal>
  </>
);

const getStepsByType = (type: string) => {
  switch (type) {
    case 'LookerStudio':
      return (
        <>
          <Typography>To get the URL of Looker Studio, you need to:</Typography>
          <ol>
            <li>Go to the report of Looker Studio you want to add</li>
            <li>Click on the dropdown button next to &ldquo;Share&ldquo;</li>
            <li>Click on Embed report and enable embedding</li>
            <li>Click on option &ldquo;Embed URL&ldquo; and copy the url</li>
          </ol>
        </>
      );
    case 'PowerApp':
      return (
        <>
          <Typography>
            Take url from PowerApp. The url is similar to:
            https://apps.powerapps.com/play/e/default-&#123;tenant_id&#125;/a/&#123;app_id&#125;
          </Typography>
          <Typography>
            If you see an error message saying you don&apos;t have access permission to add the
            report you have to:
          </Typography>
          <ol>
            <li>Go to the workspace of the app.</li>
            <li>Click on manage access.</li>
            <li>
              Add authentication-with-reporting-access (Service Principal) with member permission.
            </li>
          </ol>
        </>
      );
    case 'PowerBIReport':
      return (
        <>
          <Typography>
            Take url from PowerBi Report. The url is similar to:
            https://app.powerbi.com/groups/&#123;workspace_id&#125;/reports/&#123;report_id&#125;
          </Typography>
          <Typography>
            If you see an error message saying you don&apos;t have access permission to add the
            report you have to:
          </Typography>
          <ol>
            <li>Go to the workspace of the report.</li>
            <li>Click on manage access.</li>
            <li>
              Add authentication-with-reporting-access (Service Principal) with member permission.
            </li>
          </ol>
        </>
      );
    case 'PowerBIRepository':
      return (
        <>
          <Typography>
            Take url from PowerBi dashboard. The url is similar to:
            {/* eslint-disable-next-line max-len */}
            https://app.powerbi.com/Redirect?action=OpenDashboard&appId=&#123;app_id&#125;&dashboardObjectId=&#123;object_id&#125;
          </Typography>
          <Typography>
            If you see an error message saying you don&apos;t have access permission to add the
            report you have to:
          </Typography>
          <ol>
            <li>Go to the workspace of the dashboard.</li>
            <li>Click on manage access.</li>
            <li>
              Add authentication-with-reporting-access (Service Principal) with member permission.
            </li>
          </ol>
        </>
      );
    default:
      return <></>;
  }
};

export default AdminAddDashboardInfoModal;
